import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";

import ShareModal, { ShareModalProps } from "./ShareModal";

export default function CapabilityShareRulebookModal(props: ShareModalProps) {
  return (
    <CapabilityGate capability={SubCapabilityKey.RulebookPublicSharing}>
      <ShareModal {...props} />
    </CapabilityGate>
  );
}
